export default __webpack_public_path__ + "static/media/DogByteName.25e83fa1.svg";